import {
  useAuthInfo,
  useServerSidePagination,
  ServerDataGridTable,
  webURI,
  buildCsvColumns,
  downloadCsvViaExport,
} from "../../common";
import { allRequestsColumnConfig } from "./allRequestsColumnConfig";

// Resolves the paginated requests endpoint (after `${apiURI}/form/`) and the
// row-click destination for the user's role. Procurement and sample control see
// every request; the approver roles are scoped to their own requests.
function getRequestsConfig(decoded) {
  switch (decoded?.role) {
    case "procurement":
      return { endpoint: "requests", rowClickURI: "procurementApproval" };
    case "sampleControl":
    case "sampleControlView":
      return { endpoint: "requests", rowClickURI: "requestDetails" };
    case "chef":
      return { endpoint: `email/${decoded.email}`, rowClickURI: "requestDetails" };
    case "executiveChef":
      return {
        endpoint: `executiveChef/${decoded.email}`,
        rowClickURI: "requestDetails",
      };
    case "hod":
      return {
        endpoint: `hod/${decoded.department}`,
        rowClickURI: "requestDetails",
      };
    default:
      return { endpoint: undefined, rowClickURI: "requestDetails" };
  }
}

/**
 * AllRequests component: server-paginated, server-searched list of sample
 * requests. Each row is one request; clicking a row opens it in a new tab.
 */
export function AllRequests() {
  const decoded = useAuthInfo();
  const { endpoint, rowClickURI } = getRequestsConfig(decoded);
  const {
    rows,
    rowCount,
    paginationModel,
    setPaginationModel,
    searchModel,
    onSearchChange,
    onClearAllSearch,
    activeFilterCount,
    filterResetKey,
    sortModel,
    onSortChange,
  } = useServerSidePagination(endpoint);

  const handleRowClick = (event) => {
    window.open(`${webURI}/${rowClickURI}/${event.row.sampleRequestID}`);
  };

  return (
    <span>
      <ServerDataGridTable
        title="All Sample Requests list"
        description="Click on a row to view the corresponding sample request"
        columnConfig={allRequestsColumnConfig}
        enableSearch
        rows={rows}
        rowCount={rowCount}
        paginationModel={paginationModel}
        onPaginationModelChange={setPaginationModel}
        getRowId={(row) => row.sampleRequestID}
        onRowClick={handleRowClick}
        searchModel={searchModel}
        onSearchChange={onSearchChange}
        onClearAllSearch={onClearAllSearch}
        activeFilterCount={activeFilterCount}
        filterResetKey={filterResetKey}
        sortModel={sortModel}
        onSortChange={onSortChange}
        onExport={() =>
          downloadCsvViaExport({
            list: "requests",
            columns: buildCsvColumns(allRequestsColumnConfig),
            search: searchModel,
            sort: sortModel.length
              ? { field: sortModel[0].field, dir: sortModel[0].sort }
              : undefined,
            filename: `all-requests_${new Date()
              .toISOString()
              .slice(0, 10)}.csv`,
          })
        }
        columnGrouping
        columnGroupingModel={[
          {
            groupId: "Procurement Approval",
            description: "",
            children: [{ field: "status" }, { field: "processedBy" }],
          },
        ]}
      />
    </span>
  );
}
